import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import { webClientFileDownload } from '../../core/web_client';
import { exportFile, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { FOOD_PARTNER_ORDER_PATH } from '../../core/constants';

export const generateFoodPartnerOrderLabelsAction = createAsyncThunk(
    'inventory/generateFoodPartnerOrderLabelsAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClientFileDownload.post(`${ FOOD_PARTNER_ORDER_PATH }/${ data.id }/labels`);
            const fileName = response.headers['content-disposition']?.split('filename=')[1]?.replaceAll("\"", "");
            exportFile(extractResponseData(response), fileName ? fileName : 'naklejki.zip');
            return fulfillWithValue();
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const generateFoodPartnerOrderLabelsSlice = createSlice({
    name: 'generateFoodPartnerOrderLabelsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(generateFoodPartnerOrderLabelsAction.pending, () => STATE__API__STARTED);
        builder.addCase(generateFoodPartnerOrderLabelsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(generateFoodPartnerOrderLabelsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const generateFoodPartnerOrderLabelsState = (state) => state.inventory.generateFoodPartnerOrderLabels;
export default generateFoodPartnerOrderLabelsSlice.reducer;
